import { useQuery } from '@tanstack/react-query';
import { getActivityLog } from '../api';

export const activityLogKeys = {
  all: ['activityLog'],
  list: (params) => ['activityLog', params],
};

export function useActivityLog(params, options = {}) {
  return useQuery({
    queryKey: activityLogKeys.list(params),
    queryFn: async () => {
      const res = await getActivityLog(params);
      return res.data;
    },
    staleTime: 2 * 60 * 1000,
    ...options,
  });
}
